"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutBase = exports.GraphLayoutType = void 0;
const $ = require("jquery");
const Utilities_1 = require("../../../javascript/Utilities");
const Base_1 = require("../../../model/Base");
var GraphLayoutType;
(function (GraphLayoutType) {
    GraphLayoutType[GraphLayoutType["TdOrganigram"] = 1] = "TdOrganigram";
    GraphLayoutType[GraphLayoutType["Force"] = 3] = "Force";
    GraphLayoutType[GraphLayoutType["Layered"] = 4] = "Layered";
})(GraphLayoutType = exports.GraphLayoutType || (exports.GraphLayoutType = {}));
class LayoutBase {
    constructor($container, centerNodeId) {
        // Separation between layers
        this.m_layerSeparation = 100;
        // Spacing between label and start/end points of connection
        this.m_labelSpacingHorizontal = 5;
        // Distance between nodes within the same layer
        this.m_layerNodeDistance = 20;
        // Node widths
        // Node with icon and/or properties
        this.m_nodeWidth_Large = 225;
        this.m_nodeWidth_Small = 150;
        // Stroke thickness
        this.m_strokeWidth = 1;
        // Icon size
        this.m_iconSize = 20;
        this.m_fontFamily = "Helvetica, Verdana, sans-serif";
        // Font size for node header
        this.m_fontSizeHeader = 13;
        // Font size for additional properties
        this.m_fontSizeProps = 12;
        // Font size for labels
        this.m_fontSizeLabels = 11;
        // Horizontal padding for node header
        this.m_horizontalPaddingHeader = 2;
        // Horizontal padding for additional properties
        this.m_horizontalPaddingProps = 5;
        // Maps fontsize ==> glyph ==> width. This is used to determine the max. displayable text
        // that doesn't exceed the available width
        this.m_glyphWidthLUT = {};
        this.m_$container = $container;
        this.m_centerNodeId = centerNodeId;
    }
    panToCenterNode() {
        // Center selected node
        let diagram = this.m_$container.getKendoDiagram();
        let viewport = diagram.viewport();
        let centerNodeShape = $.grep(diagram.shapes, (shape) => shape.dataItem && shape.dataItem.instance && shape.dataItem.instance.id.value === this.m_centerNodeId)[0];
        let panToX = -1 * (Math.round(viewport.width / 2) - centerNodeShape.position().x - centerNodeShape.options.width / 2);
        let panToY = -1 * (Math.round(viewport.height / 2) - centerNodeShape.position().y - centerNodeShape.options.height / 2);
        let panPoint = new kendo.dataviz.diagram.Point(panToX, panToY);
        diagram.zoom(1);
        diagram.pan(panPoint);
    }
    drawEdgeLabels(graph, options) {
        let that = this;
        let diagram = that.m_$container.getKendoDiagram();
        let connections = diagram.connections;
        let centerNodeShape = that.getShapeMap()[that.m_centerNodeId];
        let toBackConnections = [];
        $.each(connections, (idx, connection) => {
            if (options.layoutType !== GraphLayoutType.Force) {
                let labelGroup = new kendo.dataviz.diagram.Group({ autoSize: true });
                if (!that.tryDrawMultiLineText(labelGroup, {
                    availableWidth: that.getNodeWidth(options) + that.m_layerNodeDistance,
                    fontSize: that.m_fontSizeLabels,
                    fontFamily: that.m_fontFamily,
                    text: connection.dataItem.edge.name
                })) {
                    return;
                }
                let targetPosition = connection.targetConnector.position();
                if (targetPosition.y <= centerNodeShape.getConnector("Top").position().y) {
                    let midPoints = connection.points();
                    if (midPoints.length) {
                        targetPosition = midPoints[0];
                    }
                    else
                        targetPosition.y = targetPosition.y - that.m_layerSeparation / 2;
                }
                let shape = new kendo.dataviz.diagram.Shape({
                    type: "rectangle",
                    editable: false,
                    selectable: false,
                    x: targetPosition.x + that.m_labelSpacingHorizontal,
                    y: targetPosition.y - labelGroup.drawingElement.bbox().size.height - that.m_fontSizeLabels,
                    stroke: { color: "transparent", width: 0 }
                });
                shape.visual.append(labelGroup);
                diagram.addShape(shape, false);
                toBackConnections.push(shape);
            }
            else {
                // Render text from leftmost connector point to rightmost connector point
                let sourcePoint = connection.sourcePoint();
                let targetPoint = connection.targetPoint();
                let leftPoint;
                let rightPoint;
                if (sourcePoint.x < targetPoint.x || sourcePoint.x === targetPoint.x && sourcePoint.y < targetPoint.y) {
                    leftPoint = sourcePoint;
                    rightPoint = targetPoint;
                }
                else {
                    leftPoint = targetPoint;
                    rightPoint = sourcePoint;
                }
                // Vector denoting the desired direction of the text
                let angleVector = {
                    x: rightPoint.x - leftPoint.x,
                    y: rightPoint.y - leftPoint.y
                };
                // Length of that vector
                let norm = Math.sqrt(Math.pow(angleVector.x, 2) + Math.pow(angleVector.y, 2));
                // Length available for the label
                let availableLength = norm - 2 * that.m_labelSpacingHorizontal;
                // Unit vector of angleVector
                let unit = { x: angleVector.x / norm, y: angleVector.y / norm };
                // Vector orthogonal to unitVector
                let orth = { x: unit.y, y: -unit.x };
                // Draw label within the available width. Lable may be multiline.
                let labelGroup = new kendo.dataviz.diagram.Group({ autoSize: true });
                if (!that.tryDrawMultiLineText(labelGroup, {
                    availableWidth: availableLength,
                    fontSize: that.m_fontSizeLabels,
                    fontFamily: that.m_fontFamily,
                    text: connection.dataItem.edge.name
                })) {
                    return;
                }
                let shape = new kendo.dataviz.diagram.Shape({
                    type: "rectangle",
                    editable: false,
                    selectable: false,
                    x: leftPoint.x + that.m_labelSpacingHorizontal * unit.x + (angleVector.x - labelGroup.drawingElement.bbox().size.width * unit.x) / 2 + (labelGroup.drawingElement.bbox().size.height + that.m_fontSizeLabels / 2) * orth.x,
                    y: leftPoint.y + that.m_labelSpacingHorizontal * unit.y + (angleVector.y - labelGroup.drawingElement.bbox().size.width * unit.y) / 2 + (labelGroup.drawingElement.bbox().size.height + that.m_fontSizeLabels / 2) * orth.y,
                    stroke: { color: "transparent", width: 0 }
                });
                // Since we draw from left to right without regard of what point constitutes the start and end point, we have to
                // account for negative angles here
                let sgn = leftPoint.y < rightPoint.y ? 1 : -1;
                let degreeRadians = Math.acos(angleVector.x / (Math.sqrt(Math.pow(angleVector.x, 2) + Math.pow(angleVector.y, 2))));
                shape.visual.rotate(sgn * 180 * degreeRadians / Math.PI, new kendo.dataviz.diagram.Point(0, 0));
                shape.visual.append(labelGroup);
                diagram.addShape(shape, false);
                toBackConnections.push(shape);
            }
        });
        if (toBackConnections.length)
            diagram.toBack(toBackConnections, false);
    }
    getConnectionOptions(options) {
        return {
            endCap: "ArrowEnd",
            type: "polyline",
            stroke: {
                color: options.colors.edge.stroke,
                width: this.m_strokeWidth,
            },
            hover: {
                stroke: {
                    color: options.colors.edge.strokeHover
                }
            }
        };
    }
    drawNode(node) {
        this.m_$container.getKendoDiagram().addShape(this.createNodeShape(node), false);
    }
    createNodeShape(node) {
        let that = this;
        let options = that.m_$container.data("synGraph");
        let nodeGroup = new kendo.dataviz.diagram.Group({ autoSize: true });
        let nodeWidth = that.getNodeWidth(options);
        that.drawNodeIcon(nodeGroup, node.data.instance, options);
        that.drawNodeTitle(nodeGroup, node.data.instance, options);
        that.drawProperties(nodeGroup, node.data.instance, options);
        let shape = new kendo.dataviz.diagram.Shape({
            type: "rectangle",
            editable: false,
            width: nodeWidth,
            height: nodeGroup.drawingElement.bbox().size.height,
            stroke: {
                color: options.colors.node.border,
                width: that.m_strokeWidth
            },
            fill: {
                color: node.data.id === that.m_centerNodeId ? options.colors.node.backgroundCenter : options.colors.node.background,
            },
            hover: {
                stroke: {
                    color: options.colors.node.borderHover,
                    width: that.m_strokeWidth
                },
                fill: {
                    color: options.colors.node.backgroundHover,
                }
            }
        });
        shape.visual.append(nodeGroup);
        that.setShapeDataItemProperty(shape, "instance", node.data.instance);
        return shape;
    }
    getShapeMap() {
        let shapes = this.m_$container.getKendoDiagram().shapes;
        let shapeMap = {};
        for (let i = 0; i < shapes.length; i++)
            if (shapes[i].dataItem && shapes[i].dataItem.instance && shapes[i].dataItem.instance.id)
                shapeMap[shapes[i].dataItem.instance.id.value] = shapes[i];
        return shapeMap;
    }
    zoomFit() {
        let diagram = this.m_$container.getKendoDiagram();
        let boundingBox = diagram.boundingBox();
        let viewport = diagram.viewport();
        let scaleW = 1 / (boundingBox.width / viewport.width);
        let scaleH = 1 / (boundingBox.height / viewport.height);
        let scale = Math.min(scaleW, scaleH);
        diagram.zoom(scale);
        diagram.pan(new kendo.dataviz.diagram.Point(boundingBox.x * scale - (viewport.width - boundingBox.width * scale) / 2, boundingBox.y * scale - (viewport.height - boundingBox.height * scale) / 2));
    }
    mouseEnterShape(shape) { }
    mouseEnterConnection(edge) { }
    mouseEnterMisc(item) { }
    mouseLeaveShape(shape) { }
    mouseLeaveConnection(edge) { }
    mouseLeaveMisc(item) { }
    tryDrawMultiLineText(group, textOptions) {
        if (textOptions.availableWidth < 10)
            return false;
        let x = textOptions.x || 0;
        let y = textOptions.y || 0;
        let unescapedText = textOptions.text;
        do {
            let lineText = this.getSubstringForAvailableWidth(unescapedText, textOptions.fontSize, textOptions.availableWidth, false, true);
            let lineGroup = new kendo.dataviz.diagram.Group({ autoSize: true });
            lineGroup.append(new kendo.dataviz.diagram.TextBlock({
                text: lineText,
                fontSize: textOptions.fontSize,
                fontFamily: this.m_fontFamily
            }));
            lineGroup.position(new kendo.dataviz.diagram.Point(x, y));
            y += lineGroup.drawingElement.clippedBBox().size.height;
            group.append(lineGroup);
            unescapedText = unescapedText.substring(lineText.length);
        } while (unescapedText.length > 0);
        return true;
    }
    getNodeWidth(options) {
        if (options.showDetails || options.showIcons)
            return this.m_nodeWidth_Large;
        return this.m_nodeWidth_Small;
    }
    setShapeDataItemProperty(shape, propertyName, data) {
        if (!shape.dataItem)
            shape.dataItem = {};
        shape.dataItem[propertyName] = data;
    }
    setConnectionDataItemProperty(connection, propertyName, data) {
        if (!connection.dataItem)
            connection.dataItem = {};
        connection.dataItem[propertyName] = data;
    }
    static GetNodeTitle(instance) {
        return instance.name.valueToString() || "(" + instance.items["cgdocument.docid"].valueToString() + ")";
    }
    // Updates font-size-dependent LUT for glypth widths for the text
    updateGlyphWidthLUT(text, fontSize) {
        if (!text)
            return;
        // Measure Ellipsis
        this.updateGlyphWidthLUTCore("…", fontSize);
        for (let i = 0; i < text.length; ++i)
            this.updateGlyphWidthLUTCore(text[i], fontSize);
    }
    updateGlyphWidthLUTCore(glyph, fontSize) {
        let fontSizeLUT = this.m_glyphWidthLUT[fontSize];
        if (typeof fontSizeLUT === "undefined")
            fontSizeLUT = this.m_glyphWidthLUT[fontSize] = {};
        if (typeof fontSizeLUT[glyph] === "undefined")
            fontSizeLUT[glyph] = this.getTextWidth(glyph, fontSize);
    }
    getTextWidth(text, fontSize) {
        let measureGroup = new kendo.dataviz.diagram.Group({ autoSize: true });
        measureGroup.append(new kendo.dataviz.diagram.TextBlock({ text, fontSize, fontFamily: this.m_fontFamily }));
        return measureGroup.drawingElement.bbox().size.width;
    }
    // Returns the maximum substring of text that fits available width for the given font size
    getSubstringForAvailableWidth(text, fontSize, maxAvailableWidth, addEllipsis, breakWholeWord) {
        if (!text)
            return "";
        this.updateGlyphWidthLUT(text, fontSize);
        let curWidth = 0;
        let subString = "";
        let ellipsisWidth = this.m_glyphWidthLUT[fontSize]["…"];
        for (let i = 0; i < text.length; ++i) {
            let glyph = text[i];
            let glyphWidth = this.m_glyphWidthLUT[fontSize][glyph];
            curWidth += glyphWidth;
            if (curWidth > maxAvailableWidth)
                break;
            subString += glyph;
        }
        let measureGroup = new kendo.dataviz.diagram.Group({ autoSize: true });
        measureGroup.append(new kendo.dataviz.diagram.TextBlock({ text: subString, fontSize, fontFamily: this.m_fontFamily }));
        while (measureGroup.drawingElement.bbox().size.width + (addEllipsis ? ellipsisWidth : 0) > maxAvailableWidth) {
            measureGroup.clear();
            subString = subString.substring(0, subString.length - 1);
            measureGroup.append(new kendo.dataviz.diagram.TextBlock({ text: subString, fontSize, fontFamily: this.m_fontFamily }));
        }
        if (subString.length < text.length) {
            if (addEllipsis && !breakWholeWord)
                return subString + "…";
            if (breakWholeWord && text[subString.length] !== " ") {
                let lastWhiteSpaceIdx = subString.lastIndexOf(" ");
                if (lastWhiteSpaceIdx > 0 && lastWhiteSpaceIdx < subString.length - 1)
                    return subString.substring(0, lastWhiteSpaceIdx);
            }
        }
        return subString;
    }
    // Draws node header
    drawNodeTitle(group, instance, options) {
        let nodeWidth = this.getNodeWidth(options);
        let title = LayoutBase.GetNodeTitle(instance);
        let offsetX = options.showIcons ? this.m_iconSize + this.m_horizontalPaddingHeader : this.m_horizontalPaddingHeader;
        let availableWidth = nodeWidth - offsetX - this.m_horizontalPaddingHeader;
        let textWidth = this.getTextWidth(title, this.m_fontSizeHeader);
        let exceedsLine = textWidth > availableWidth;
        if (options.multiLineTitle && exceedsLine) {
            this.tryDrawMultiLineText(group, {
                text: title,
                fontSize: this.m_fontSizeHeader,
                fontFamily: this.m_fontFamily,
                x: offsetX,
                availableWidth
            });
        }
        else {
            // Render text centered
            let truncatedText = this.getSubstringForAvailableWidth(title, this.m_fontSizeHeader, availableWidth, true, false);
            let measureGroup = new kendo.dataviz.diagram.Group({ autoSize: true });
            measureGroup.append(new kendo.dataviz.diagram.TextBlock({
                text: truncatedText,
                fontSize: this.m_fontSizeHeader,
                fontFamily: this.m_fontFamily
            }));
            let measureGroupWidth = measureGroup.drawingElement.bbox().size.width;
            if (availableWidth - measureGroupWidth < offsetX)
                measureGroup.position(new kendo.dataviz.diagram.Point(offsetX, 0));
            else
                measureGroup.position(new kendo.dataviz.diagram.Point((nodeWidth - measureGroup.drawingElement.bbox().size.width) / 2, 0));
            group.append(measureGroup);
        }
    }
    // Draws node icon (if icon drawing is enabled)
    drawNodeIcon(group, instance, options) {
        if (options.showIcons) {
            let iconRect = {
                x: this.m_strokeWidth / 2,
                y: this.m_strokeWidth / 2,
                width: this.m_iconSize - 2 * this.m_strokeWidth,
                height: this.m_iconSize - 2 * this.m_strokeWidth
            };
            let bg = new kendo.dataviz.diagram.Rectangle({
                x: iconRect.x,
                y: iconRect.y,
                width: iconRect.width,
                height: iconRect.height,
                stroke: {
                    color: "transparent"
                },
                fill: "#fff"
            });
            group.append(bg);
            let icon = new kendo.dataviz.diagram.Image({
                source: Utilities_1.synUtil.getWSUrl("Icon") + instance.icon.value + "/96",
                x: iconRect.x,
                y: iconRect.y,
                width: iconRect.width,
                height: iconRect.height,
            });
            group.append(icon);
        }
    }
    // Draws additional properties
    drawProperties(nodeGroup, instance, options) {
        if (options.showDetails) {
            let that = this;
            let typeId = instance.items["cgdocument.typeid"].valueToNumber(1);
            let props = Utilities_1.synUtil.Configs.getValue("graph.nodeproperties", undefined, typeId);
            if (props) {
                let nodeWidth = that.getNodeWidth(options);
                let yOffset = nodeGroup.drawingElement.bbox().size.height;
                let propStrokeWidth = that.m_strokeWidth / 2;
                let doublePadding = 2 * that.m_horizontalPaddingProps;
                let strokeAndPadding = doublePadding + that.m_strokeWidth;
                let maxPropKeyWidth = nodeWidth / 2 - strokeAndPadding;
                $.each(props.split("|"), (idx, prop) => {
                    if (!prop)
                        return true;
                    let propKey = Utilities_1.synUtil.Strings.getValue(prop, undefined, typeId);
                    let propVal = that.getPropString(instance.items[prop]);
                    // Create prop key group
                    let propKeyGroup = new kendo.dataviz.diagram.Group({ y: yOffset, autoSize: true });
                    if (!that.tryDrawMultiLineText(propKeyGroup, {
                        text: propKey,
                        fontSize: that.m_fontSizeProps,
                        fontFamily: that.m_fontFamily,
                        x: that.m_horizontalPaddingProps + propStrokeWidth,
                        availableWidth: maxPropKeyWidth
                    })) {
                        return;
                    }
                    let propKeyGroupWidth = propKeyGroup.drawingElement.bbox().size.width;
                    // Create prop value group
                    let propValueGroup = new kendo.dataviz.diagram.Group({
                        x: propKeyGroup.drawingElement.bbox().size.width + that.m_horizontalPaddingProps + propStrokeWidth,
                        y: yOffset,
                        autoSize: true
                    });
                    if (!that.tryDrawMultiLineText(propValueGroup, {
                        text: propVal,
                        fontSize: that.m_fontSizeProps,
                        fontFamily: that.m_fontFamily,
                        x: doublePadding,
                        availableWidth: nodeWidth - propKeyGroupWidth - strokeAndPadding - doublePadding
                    })) {
                        return;
                    }
                    let maxHeight = Math.max(propKeyGroup.drawingElement.bbox().size.height, propValueGroup.drawingElement.bbox().size.height);
                    // Draw prop key rectangle (height=max(key group, value group))
                    nodeGroup.append(new kendo.dataviz.diagram.Rectangle({
                        x: 0,
                        y: yOffset,
                        width: propKeyGroupWidth + doublePadding,
                        height: maxHeight,
                        stroke: {
                            color: "#000",
                            width: propStrokeWidth
                        },
                        fill: {
                            color: "#fff",
                            opacity: 0.5
                        }
                    }));
                    // Draw prop value rectangle
                    nodeGroup.append(new kendo.dataviz.diagram.Rectangle({
                        x: propKeyGroupWidth + doublePadding,
                        y: yOffset,
                        width: nodeWidth - propKeyGroupWidth - doublePadding,
                        height: maxHeight,
                        stroke: {
                            color: "#000",
                            width: propStrokeWidth
                        },
                        fill: {
                            color: "#fff"
                        }
                    }));
                    // Draw prop key group
                    nodeGroup.append(propKeyGroup);
                    // Draw prop value group
                    nodeGroup.append(propValueGroup);
                    // Increment yOffset
                    yOffset += maxHeight;
                });
            }
        }
    }
    getPropString(field) {
        if (typeof field === "undefined")
            return "";
        if (field.multiValue) {
            let str = "";
            for (let i = 0; i < field.valueAsArray.length; i++) {
                if (i > 0)
                    str += ";";
                str += this.getPropStringCore(field.type, field.valueAsArray[i]);
            }
            return str;
        }
        else
            return this.getPropStringCore(field.type, field.value);
    }
    getPropStringCore(fieldType, fieldValue) {
        if (!fieldValue)
            return "";
        switch (fieldType) {
            case Base_1.FieldType.Date:
                return kendo.toString(fieldValue, "d");
            case Base_1.FieldType.DateTime:
                return kendo.toString(fieldValue, "G");
            case Base_1.FieldType.Time:
                return kendo.toString(fieldValue, "T");
            case Base_1.FieldType.Bool:
                return (fieldValue ? "Y" : "N");
            case Base_1.FieldType.Float:
                return kendo.toString(fieldValue, "n2");
            case Base_1.FieldType.Digit:
            case Base_1.FieldType.BigDigit:
            default:
                return fieldValue.toString();
        }
    }
}
exports.LayoutBase = LayoutBase;
